import { Box, Typography } from '@mui/material'
import { useLayoutEffect } from 'react'
import { aboutContent } from './aboutContent'
import {
  aboutCapabilityItemSx,
  aboutCapabilityListSx,
  aboutCapabilityTitleSx,
  aboutPageSx,
  aboutParagraphSx,
  aboutSectionSx,
  aboutSectionTitleSx,
  aboutStepsSx,
  aboutTitleSx,
} from './style'

export const About = () => {
  useLayoutEffect(() => {
    document.title = aboutContent.documentTitle
  }, [])

  return (
    <Box sx={aboutPageSx}>
      <Typography variant="h1" sx={aboutTitleSx}>
        {aboutContent.h1}
      </Typography>

      {aboutContent.intro.map((paragraph) => (
        <Typography key={paragraph} sx={aboutParagraphSx}>
          {paragraph}
        </Typography>
      ))}

      <Box component="section" sx={aboutSectionSx}>
        <Typography variant="h2" sx={aboutSectionTitleSx}>
          {aboutContent.forWhom.title}
        </Typography>
        {aboutContent.forWhom.paragraphs.map((paragraph) => (
          <Typography key={paragraph} sx={aboutParagraphSx}>
            {paragraph}
          </Typography>
        ))}
      </Box>

      <Box component="section" sx={aboutSectionSx}>
        <Typography variant="h2" sx={aboutSectionTitleSx}>
          {aboutContent.capabilities.title}
        </Typography>
        <Box component="ul" sx={aboutCapabilityListSx}>
          {aboutContent.capabilities.items.map((item) => (
            <Box component="li" key={item.title} sx={aboutCapabilityItemSx}>
              <Typography sx={aboutCapabilityTitleSx}>{item.title}</Typography>
              <Typography sx={aboutParagraphSx}>{item.description}</Typography>
            </Box>
          ))}
        </Box>
      </Box>

      <Box component="section" sx={aboutSectionSx}>
        <Typography variant="h2" sx={aboutSectionTitleSx}>
          {aboutContent.howToStart.title}
        </Typography>
        <Box component="ol" sx={aboutStepsSx}>
          {aboutContent.howToStart.steps.map((step) => (
            <Typography component="li" key={step}>
              {step}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
